module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Abtwil_AG-4642ae28fc82ece9fb5aa4cc1f13e65a.svg";